// MUI components
import FaiBadge from "../../../../MuiComponents/FaiBadge";
import { ColumnData } from "../../../../assets/types/ColumnData";
import FaiBox from "../../../../MuiComponents/FaiBox";
import { alpha, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SwitchProps } from "@mui/material/Switch/Switch";

// Badges
const outOfStock = (
	<FaiBadge
		variant="contained"
		color="error"
		size="xs"
		badgeContent="out of stock"
		container
	/>
);
const inStock = (
	<FaiBadge
		variant="contained"
		color="success"
		size="xs"
		badgeContent="in stock"
		container
	/>
);
const CustomSwitch = styled(Switch)<SwitchProps>(({ theme }) => {
	return {
		"& .MuiSwitch-switchBase.Mui-checked": {
			color: theme.palette.success.main,
			"&:hover": {
				backgroundColor: alpha(
					theme.palette.success.main,
					theme.palette.action.hoverOpacity
				),
			},
		},
		"& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
			backgroundColor: theme.palette.success.main + " !important",
			borderColor: theme.palette.success.main + " !important",
		},
	};
});

const columns: ColumnData[] = [
	{
		Header: "article name",
		accessor: "articleName",
		Cell: ({ row }) => {
			return (
				<div
					style={{
						maxWidth: "300px",
						display: "-webkit-box",
						WebkitLineClamp: 3,
						WebkitBoxOrient: "vertical",
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "normal",
					}}
				>
					{row.original.articleName}
				</div>
			);
		},
	},
	{ Header: "SKU Code", accessor: "skuCode" },
	{ Header: "brand name", accessor: "brandName" },
	{ Header: "category", accessor: "category" },
	{
		Header: "status",
		accessor: "status",
		Cell: ({ value }) => {
			return value === "in stock" ? inStock : outOfStock;
		},
	},
	{
		Header: "published",
		accessor: "published",
		// Cell: ({ value }) => {
		// 	return <>AAAAAA</>;
		// 	return <CustomSwitch checked={value} />;
		// },
	},
	{
		Header: "Actions",
		accessor: "edit",
		// Cell definition removed to allow ProductList.tsx to handle it
	},
];

const rows: any = [];

const dataTableData = {
	columns,
	rows,
};

export default dataTableData;
